/* eslint @typescript-eslint/camelcase: 0 */

import {HcmRouteConfig} from "@/router";
import {Route} from "vue-router";
import DraftContract from "@/components/pages/contract/TradeContract/DraftContract/index.vue";
import DraftContract_DataProfile from "@/components/pages/contract/TradeContract/DraftContract/DataProfile.vue";
import DraftContract_ServiceProfile from "@/components/pages/contract/TradeContract/ServiceProfile.vue";
import DraftContract_ContractProfile from "@/components/pages/contract/TradeContract/ContractProfileTemplate.vue";
import DraftContract_Complete from "@/components/pages/contract/TradeContract/Complete.vue";
import AdaptContract from "@/components/pages/contract/TradeContract/AdaptContract/index.vue";
import AdaptContract_DataProfile from "@/components/pages/contract/TradeContract/AdaptContract/DataProfile.vue";
import AdaptContract_ServiceProfile from "@/components/pages/contract/TradeContract/ServiceProfile.vue";
import AdaptContract_ContractProfile from "@/components/pages/contract/TradeContract/ContractProfile.vue";
import AdaptContract_Complete from "@/components/pages/contract/TradeContract/Complete.vue";
import ViewContract from "@/components/pages/contract/TradeContract/ViewContract/index.vue";
import TradeContractList from "@/components/pages/contract/TradeContractList/index.vue";
import TradeContractList_Public from "@/components/pages/contract/TradeContractList/PublicTab.vue";
import TradeContractList_Pretrading from "@/components/pages/contract/TradeContractList/PretradingTab.vue";
import TradeContractList_Trading from "@/components/pages/contract/TradeContractList/TradingTab.vue";
import TradeContractList_Suspended from "@/components/pages/contract/TradeContractList/SuspendedTab.vue";
import TradeResultList from "@/components/pages/contract/TradeResultList/index.vue";
import TradeResultList_TradeContractTable from "@/components/pages/contract/TradeResultList/TradeContractTable.vue";
import TradeResultList_TradeContractTableForData from "@/components/pages/contract/TradeResultList/TradeContractTableForData.vue";
import TradeContractCreate from "@/components/pages/contract/TradeContractCreate/index.vue";
import TradeContractCreate_DataProfile from "@/components/pages/profile/ProfileManagement/DataProfileTab.vue";
import TradeContractCreate_FormatGroup from "@/components/pages/contract/TradeContractCreate/FormatGroupTab.vue";
import TradeResultShow from "@/components/pages/contract/TradeResultShow/index.vue";
import TradeResultShowForData from "@/components/pages/contract/TradeResultShowForData/index.vue";
import MessageShow from "@/components/pages/contract/MessageShow/index.vue";
import TradeContractFormatList from "@/components/pages/contract/TradeContractFormatList/index.vue";
import TradeContractFormatList_Format from "@/components/pages/contract/TradeContractFormatList/FormatTab.vue";
import TradeContractFormatList_FormatGroup from "@/components/pages/contract/TradeContractFormatList/FormatGroupTab.vue";
import TradeContractFormat_DraftContract from "@/components/pages/contract/TradeContractFormat/DraftContract/index.vue";
import TradeContractFormat_FormatGroups from "@/components/pages/contract/TradeContractFormat/FormatGroups.vue";
import TradeContractFormat_Complete from "@/components/pages/contract/TradeContractFormat/Complete.vue";
import TradeContractFormatCreate from "@/components/pages/contract/TradeContractFormatCreate/index.vue";
import TradeContractFormatGroup from "@/components/pages/contract/TradeContractFormatGroup/index.vue";
import TradeContractFormat_CompanionServiceProfile from "@/components/pages/contract/TradeContractFormat/CompanionServiceProfile.vue";
import ProfileManagement_DataProfile from "@/components/pages/profile/ProfileManagement/DataProfile/index.vue";


const propsTcChildren = (route: Route) => ({
  ...route.params,
  tradeContractIndex: route.params.tradeContractIndex
    ? Number.parseInt(route.params.tradeContractIndex, 10)
    : null,
});

const routes: HcmRouteConfig[] = [
  /********************************************************************************************************************
   * 取引管理
   ********************************************************************************************************************/

  // 取引契約管理
  {
    path: '/browse/tradeContract/list',
    name: '/browse/tradeContract/list',
    component: TradeContractList,
    meta: {
      label: '取引契約管理',
      parent: 'Home',
      permissions: ['!contract'],
      fallback: '/edit/tradeContract/list',
    },
    children: [{
      path: 'pretrading',
      name: '/browse/tradeContract/list/pretrading',
      component: TradeContractList_Pretrading
    }, {
      path: 'public',
      props: route => ({selection: route.query.selection}),
      name: '/browse/tradeContract/list/public',
      component: TradeContractList_Public
    }, {
      path: 'trading',
      name: '/browse/tradeContract/list/trading',
      component: TradeContractList_Trading
    }, {
      path: 'suspended',
      name: '/browse/tradeContract/list/suspended',
      component: TradeContractList_Suspended
    }]
  }, {
    path: '/edit/tradeContract/list',
    name: '/edit/tradeContract/list',
    component: TradeContractList,
    meta: {
      label: '取引契約管理',
      parent: 'Home',
      permissions: ['contract'],
      fallback: '/browse/tradeContract/list',
    },
    children: [{
      path: 'pretrading',
      name: '/edit/tradeContract/list/pretrading',
      component: TradeContractList_Pretrading
    }, {
      path: 'public',
      props: route => ({selection: route.query.selection}),
      name: '/edit/tradeContract/list/public',
      component: TradeContractList_Public
    }, {
      path: 'trading',
      name: '/edit/tradeContract/list/trading',
      component: TradeContractList_Trading
    }, {
      path: 'suspended',
      name: '/edit/tradeContract/list/suspended',
      component: TradeContractList_Suspended
    }]
  },

  // 取引契約管理 ⇒ 取引契約作成
  {
    path: '/edit/tradeContract/create',
    name: '/edit/tradeContract/create',
    component: TradeContractCreate,
    meta: {
      label: '取引契約作成',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
      fallback: '/browse/tradeContract/list',
    },
    children: [{
      path: 'dataProfile',
      name: '/edit/tradeContract/create/dataProfile',
      component: TradeContractCreate_DataProfile,
      props: route => ({
        ...route.params,
        nextPageName: '/edit/tradeContract/create/dataProfile/preview',
      }),
    }, {
      path: 'formatGroup',
      name: '/edit/tradeContract/create/formatGroup',
      component: TradeContractCreate_FormatGroup,
    }]
  },

  // 取引契約管理 ⇒ 取引契約作成 ⇒ データプロファイル閲覧
  {
    path: '/edit/tradeContract/create/dataProfile/preview/:dataProfileId',
    name: '/edit/tradeContract/create/dataProfile/preview',
    component: ProfileManagement_DataProfile,
    props: route => ({
      ...route.params,
      initialCreateMode: 'tradeContract',
      hideCreateModeToggle: true,
      showCreateMessage: '取引契約を作成することができます',
    }),
    meta: {
      label: 'データプロファイル閲覧',
      parent: '/edit/tradeContract/create/dataProfile',
      permissions: ['contract'],
      isOwnedDataProfile: true,
    }
  },


  /**********************************************
   * 起案申請型 取引契約
   **********************************************/

  // 契約起案申請フロー (起案型画面)
  {
    path: '/draftContract/:tradeContractId',
    name: '/draftContract',
    component: DraftContract,
    props: true,
    meta: {
      label: '契約起案申請フロー',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
    },
    children: [{
      name: '/draftContract/dataProfile',
      path: ':tradeContractIndex/dataProfile',
      component: DraftContract_DataProfile,
      props: propsTcChildren,
    }, {
      name: '/draftContract/serviceProfile',
      path: ':tradeContractIndex/serviceProfile',
      component: DraftContract_ServiceProfile,
      props: propsTcChildren,
    }, {
      name: '/draftContract/contractProfile',
      path: ':tradeContractIndex/contractProfile',
      component: DraftContract_ContractProfile,
      props: propsTcChildren,
    }, {
      name: '/draftContract/complete',
      path: 'complete',
      component: DraftContract_Complete,
      props: propsTcChildren,
      meta: {
        subtitle: '中断する事で途中保存、申請する事で取引の送信を行います。'
      },
    }]
  },

  // 契約起案承認フロー (適応型画面)
  {
    path: '/adaptContract/:tradeContractId',
    name: '/adaptContract',
    component: AdaptContract,
    props: true,
    meta: {
      label: '契約起案承認フロー',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
    },
    children: [{
      name: '/adaptContract/dataProfile',
      path: ':tradeContractIndex/dataProfile',
      component: AdaptContract_DataProfile,
      props: propsTcChildren,
    }, {
      name: '/adaptContract/serviceProfile',
      path: ':tradeContractIndex/serviceProfile',
      component: AdaptContract_ServiceProfile,
      props: propsTcChildren,
    }, {
      name: '/adaptContract/contractProfile',
      path: ':tradeContractIndex/contractProfile',
      component: AdaptContract_ContractProfile,
      props: propsTcChildren,
    }, {
      name: '/adaptContract/complete',
      path: 'complete',
      component: AdaptContract_Complete,
      props: propsTcChildren,
      meta: {
        subtitle: '中断する事で途中保存、または次のステータスに遷移することができます。'
      },
    }]
  },

  /**********************************************
   * 申込申請型 取引契約
   **********************************************/

  // 契約申込申請フロー (適応型画面)
  {
    path: '/offerContract/:tradeContractId',
    name: '/offerContract',
    component: AdaptContract,
    props: true,
    meta: {
      label: '契約申込申請フロー',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
    },
    children: [{
      name: '/offerContract/dataProfile',
      path: ':tradeContractIndex/dataProfile',
      component: AdaptContract_DataProfile,
      props: propsTcChildren,
    }, {
      name: '/offerContract/serviceProfile',
      path: ':tradeContractIndex/serviceProfile',
      component: AdaptContract_ServiceProfile,
      props: propsTcChildren,
    }, {
      name: '/offerContract/contractProfile',
      path: ':tradeContractIndex/contractProfile',
      component: DraftContract_ContractProfile,
      props: propsTcChildren,
    }, {
      name: '/offerContract/complete',
      path: 'complete',
      component: AdaptContract_Complete,
      props: propsTcChildren,
      meta: {
        subtitle: '中断する事で途中保存、または次のステータスに遷移することができます。'
      },
    }]
  },

  /**********************************************
   * 募集型 取引契約
   **********************************************/

  // 契約募集フロー (起案型画面)
  {
    path: '/publishContract/:tradeContractId',
    name: '/publishContract',
    component: DraftContract,
    props: true,
    meta: {
      label: '契約募集フロー',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
    },
    children: [{
      name: '/publishContract/dataProfile',
      path: ':tradeContractIndex/dataProfile',
      component: DraftContract_DataProfile,
      props: propsTcChildren,
    }, {
      name: '/publishContract/serviceProfile',
      path: ':tradeContractIndex/serviceProfile',
      component: DraftContract_ServiceProfile,
      props: propsTcChildren,
    }, {
      name: '/publishContract/contractProfile',
      path: ':tradeContractIndex/contractProfile',
      component: DraftContract_ContractProfile,
      props: propsTcChildren,
    }, {
      name: '/publishContract/complete',
      path: 'complete',
      component: DraftContract_Complete,
      props: propsTcChildren,
      meta: {
        subtitle: '中断する事で途中保存、募集する事で取引の送信を行います。'
      },
    }]
  },

  /**********************************************
   * 申込型 取引契約
   **********************************************/

  // 契約申込フロー (適応型画面)
  {
    path: '/subscribeContract/:tradeContractId',
    name: '/subscribeContract',
    component: AdaptContract,
    props: true,
    meta: {
      label: '契約申込フロー',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
    },
    children: [{
      name: '/subscribeContract/dataProfile',
      path: ':tradeContractIndex/dataProfile',
      component: AdaptContract_DataProfile,
      props: propsTcChildren,
    }, {
      name: '/subscribeContract/serviceProfile',
      path: ':tradeContractIndex/serviceProfile',
      component: AdaptContract_ServiceProfile,
      props: propsTcChildren,
    }, {
      name: '/subscribeContract/contractProfile',
      path: ':tradeContractIndex/contractProfile',
      component: AdaptContract_ContractProfile,
      props: propsTcChildren,
    }, {
      name: '/subscribeContract/complete',
      path: 'complete',
      component: AdaptContract_Complete,
      props: propsTcChildren,
      meta: {
        subtitle: '中断する事で途中保存、または次のステータスに遷移することができます。'
      },
    }]
  },

  // 契約申込承認フロー (起案型画面)
  {
    path: '/applyContract/:tradeContractId',
    name: '/applyContract',
    component: DraftContract,
    props: true,
    meta: {
      label: '契約申込承認フロー',
      parent: '/edit/tradeContract/list',
      permissions: ['contract'],
    },
    children: [{
      name: '/applyContract/dataProfile',
      path: ':tradeContractIndex/dataProfile',
      component: DraftContract_DataProfile,
      props: propsTcChildren,
    }, {
      name: '/applyContract/serviceProfile',
      path: ':tradeContractIndex/serviceProfile',
      component: DraftContract_ServiceProfile,
      props: propsTcChildren,
    }, {
      name: '/applyContract/contractProfile',
      path: ':tradeContractIndex/contractProfile',
      component: AdaptContract_ContractProfile,
      props: propsTcChildren,
    }, {
      name: '/applyContract/complete',
      path: 'complete',
      component: DraftContract_Complete,
      props: propsTcChildren,
      meta: {
        subtitle: '中断する事で途中保存、承認する事で取引の送信を行います。'
      },
    }]
  },

  /**********************************************
   * 汎用
   **********************************************/

  // 契約照会
  {
    path: '/viewContract/:tradeContractId',
    name: '/viewContract',
    component: ViewContract,
    props: true,
    meta: {
      label: '契約照会',
      parent: '/edit/tradeContract/list/trading',
      permissions: ['contract'],
    },
  },


  /********************************************************************************************************************
   * 取引実績管理
   ********************************************************************************************************************/
  {
    path: '/browse/list/tradeResult',
    name: '/browse/list/tradeResult/TradeResultList',
    component: TradeResultList,
    meta: {
      label: '取引実績管理',
      parent: 'Home',
      permissions: ['!implementation'],
      fallback: '/edit/list/tradeResult/TradeResultList',
    },
    children: [{
      path: 'tradeContracts',
      name: '/browse/list/tradeResult/TradeResultList/tradeContracts',
      component: TradeResultList_TradeContractTable
    }, {
      path: 'dataImplementations',
      name: '/browse/list/tradeResult/TradeResultList/dataImplementations',
      component: TradeResultList_TradeContractTableForData
    }]
  }, {
    path: '/edit/list/tradeResult',
    name: '/edit/list/tradeResult/TradeResultList',
    component: TradeResultList,
    meta: {
      label: '取引実績管理',
      parent: 'Home',
      permissions: ['implementation'],
      fallback: '/browse/list/tradeResult/TradeResultList',
    },
    children: [{
      path: 'tradeContracts',
      name: '/edit/list/tradeResult/TradeResultList/tradeContracts',
      component: TradeResultList_TradeContractTable
    }, {
      path: 'dataImplementations',
      name: '/edit/list/tradeResult/TradeResultList/dataImplementations',
      component: TradeResultList_TradeContractTableForData
    }]
  },

  {
    path: '/browse/list/tradeResult/:tradeContractId',
    name: '/browse/list/tradeResult/TradeResultShow',
    component: TradeResultShow,
    props: true,
    meta: {
      label: '取引データ一覧(契約単位)',
      parent: '/edit/list/tradeResult/TradeResultList/tradeContracts',
      permissions: ['!implementation'],
      fallback: '/edit/list/tradeResult/TradeResultShow',
    }
  }, {
    path: '/edit/list/tradeResult/:tradeContractId',
    name: '/edit/list/tradeResult/TradeResultShow',
    component: TradeResultShow,
    props: true,
    meta: {
      label: '取引データ一覧(契約単位)',
      parent: '/edit/list/tradeResult/TradeResultList/tradeContracts',
      permissions: ['implementation'],
      fallback: '/browse/list/tradeResult/TradeResultShow',
    }
  },

  {
    path: '/browse/list/tradeResultForData/:dataImplementationId',
    name: '/browse/list/tradeResultForData/TradeResultShowForData',
    component: TradeResultShowForData,
    props: true,
    meta: {
      label: '取引データ一覧(データ実装単位)',
      parent: '/edit/list/tradeResult/TradeResultList/dataImplementations',
      permissions: ['!implementation'],
      fallback: '/edit/list/tradeResultForData/TradeResultShow',
    }
  }, {
    path: '/edit/list/tradeResultForData/:dataImplementationId',
    name: '/edit/list/tradeResultForData/TradeResultShowForData',
    component: TradeResultShowForData,
    props: true,
    meta: {
      label: '取引データ一覧(データ実装単位)',
      parent: '/edit/list/tradeResult/TradeResultList/dataImplementations',
      permissions: ['implementation'],
      fallback: '/browse/list/tradeResultForData/TradeResultShowForData',
    }
  },

  {
    path: '/browse/list/tradeResult/:tradeContractId/message/:messageId/messageHistory/:messageHistoryId',
    name: '/browse/list/tradeResult/MessageShow',
    component: MessageShow,
    props: true,
    meta: {
      label: '取引データ記録',
      parent: '/edit/list/tradeResult/TradeResultShow',
      permissions: ['!implementation'],
      fallback: '/edit/list/tradeResult/MessageShow',
    }
  }, {
    path: '/edit/list/tradeResult/:tradeContractId/message/:messageId/messageHistory/:messageHistoryId',
    name: '/edit/list/tradeResult/MessageShow',
    component: MessageShow,
    props: true,
    meta: {
      label: '取引データ記録',
      parent: '/edit/list/tradeResult/TradeResultShow',
      permissions: ['implementation'],
      fallback: '/browse/list/tradeResult/MessageShow',
    }
  },

  {
    path: '/browse/list/tradeResultForData/:dataImplementationId/message/:messageId/messageHistory/:messageHistoryId',
    name: '/browse/list/tradeResultForData/MessageShow',
    component: MessageShow,
    props: true,
    meta: {
      label: '取引データ記録',
      parent: '/edit/list/tradeResultForData/TradeResultShowForData',
      permissions: ['!implementation'],
      fallback: '/edit/list/tradeResultForData/MessageShow',
    }
  }, {
    path: '/edit/list/tradeResultForData/:dataImplementationId/message/:messageId/messageHistory/:messageHistoryId',
    name: '/edit/list/tradeResultForData/MessageShow',
    component: MessageShow,
    props: true,
    meta: {
      label: '取引データ記録',
      parent: '/edit/list/tradeResultForData/TradeResultShowForData',
      permissions: ['implementation'],
      fallback: '/browse/list/tradeResultForData/MessageShow',
    }
  },

  /********************************************************************************************************************
   * 取引フォーマット管理
   ********************************************************************************************************************/
  // 取引契約フォーマット・フォーマットグループ一覧
  {
    path: '/browse/tradeFormat/list',
    name: '/browse/tradeFormat/list',
    component: TradeContractFormatList,
    meta: {
      label: '取引フォーマット管理',
      parent: 'Home',
      permissions: ['!contract'],
      fallback: '/edit/tradeFormat/list',
    },
    children: [{
      path: 'format',
      name: '/browse/tradeFormat/list/format',
      component: TradeContractFormatList_Format
    }, {
      path: 'formatGroup',
      name: '/browse/tradeFormat/list/formatGroup',
      component: TradeContractFormatList_FormatGroup
    }]
  }, {
    path: '/edit/tradeFormat/list',
    name: '/edit/tradeFormat/list',
    component: TradeContractFormatList,
    meta: {
      label: '取引フォーマット管理',
      parent: 'Home',
      permissions: ['contract'],
      fallback: '/browse/tradeFormat/list',
    },
    children: [{
      path: 'format',
      name: '/edit/tradeFormat/list/format',
      component: TradeContractFormatList_Format
    }, {
      path: 'formatGroup',
      name: '/edit/tradeFormat/list/formatGroup',
      component: TradeContractFormatList_FormatGroup
    }]
  },

  // 取引契約フォーマット一覧 ⇒ 取引契約フォーマット編集
  {
    path: '/edit/tradeFormat/:tradeContractFormatId',
    name: '/edit/tradeFormat',
    component: TradeContractFormat_DraftContract,
    props: true,
    meta: {
      label: '取引契約フォーマット編集',
      parent: '/edit/tradeFormat/list/format',
      permissions: ['contract'],
    },
    children: [{
      name: '/edit/tradeFormat/dataProfile',
      path: 'dataProfile',
      component: DraftContract_DataProfile,
      meta: {
        label: '発行側データ',
      },
    }, {
      name: '/edit/tradeFormat/serviceProfile',
      path: 'serviceProfile',
      component: DraftContract_ServiceProfile,
      meta: {
        label: '発行側サービス',
      },
    }, {
      name: '/edit/tradeFormat/companionServiceProfile',
      path: 'companionServiceProfile',
      component: TradeContractFormat_CompanionServiceProfile,
      meta: {
        label: '受領側サービス',
      },
    }, {
      name: '/edit/tradeFormat/contractProfile',
      path: 'contractProfile',
      component: DraftContract_ContractProfile,
    }, {
      name: '/edit/tradeFormat/groups',
      path: 'groups',
      component: TradeContractFormat_FormatGroups,
      meta: {
        label: 'グループ',
      },
    }, {
      name: '/edit/tradeFormat/complete',
      path: 'complete',
      component: TradeContractFormat_Complete,
    }]
  },

  // 取引契約フォーマットグループ一覧 ⇒ 取引契約フォーマットグループ編集
  {
    path: '/browse/tradeFormatGroup/:tradeContractFormatGroupId',
    name: '/browse/tradeFormatGroup',
    component: TradeContractFormatGroup,
    props: true,
    meta: {
      label: '取引契約フォーマットグループ閲覧',
      parent: '/edit/tradeFormat/list/formatGroup',
      permissions: ['!contract'],
    },
  }, {
    path: '/edit/tradeFormatGroup/:tradeContractFormatGroupId',
    name: '/edit/tradeFormatGroup',
    component: TradeContractFormatGroup,
    props: true,
    meta: {
      label: '取引契約フォーマットグループ編集',
      parent: '/edit/tradeFormat/list/formatGroup',
      permissions: ['contract'],
    },
  },

  // 取引契約フォーマット一覧 ⇒ 取引契約フォーマット作成
  {
    path: '/edit/tradeFormat/format/create',
    name: '/edit/tradeFormat/format/create',
    component: TradeContractFormatCreate,
    meta: {
      label: '取引契約フォーマット作成',
      parent: '/edit/tradeFormat/list/format',
      permissions: ['contract'],
    },
    children: [{
      path: 'dataProfile',
      name: '/edit/tradeFormat/format/create/dataProfile',
      component: TradeContractCreate_DataProfile,
      props: route => ({
        ...route.params,
        nextPageName: '/edit/tradeFormat/format/create/dataProfile/preview',
      }),
    }]
  },

  // 取引契約フォーマット一覧 ⇒ 取引契約フォーマット作成 ⇒ データプロファイル閲覧
  {
    path: '/edit/tradeFormat/format/create/dataProfile/preview/:dataProfileId',
    name: '/edit/tradeFormat/format/create/dataProfile/preview',
    component: ProfileManagement_DataProfile,
    props: route => ({
      ...route.params,
      initialCreateMode: 'tradeContractFormat',
      hideCreateModeToggle: true,
      showCreateMessage: '取引契約フォーマットを作成することができます',
    }),
    meta: {
      label: 'データプロファイル閲覧',
      parent: '/edit/tradeFormat/format/create',
      permissions: ['contract'],
      isOwnedDataProfile: true,
    }
  },
];

export default routes;
